import { TourCardSlider } from "@wojo/storyblok";
import { Container, Text } from "@wojo/ui";
import { useTourPageContext } from "../../_client/context";
import { useI18n } from "@wojo/localization";
import styles from "./RelatedTours.module.scss";
import { useId } from "react";

export const RelatedTours: React.FC = () => {
    const {
        storyblokPageUid,
        relatedToursHeading,
        relatedToursAlgoliaContext,
    } = useTourPageContext();
    const { productPage } = useI18n("productPage");
    const headingId = useId();

    if (!relatedToursAlgoliaContext) {
        return null;
    }

    return (
        <section
            className={styles["related-tours"]}
            aria-labelledby={headingId}
        >
            <Container>
                <Text.Heading
                    order="3"
                    tag="h2"
                    style={{ marginBottom: "var(--g-spacing-lg)" }}
                    id={headingId}
                >
                    {relatedToursHeading ||
                        productPage.relatedTours.heading.l()}
                </Text.Heading>
            </Container>
            <TourCardSlider
                _uid={storyblokPageUid}
                algoliaRuleTriggerContext={relatedToursAlgoliaContext}
                numberOfTours={{
                    plugin: "storyblok-slider",
                    value: 20,
                }}
            />
        </section>
    );
};
